// longitude = d'est en ouest
// latitude = du nord au sud

const placesContainer = document.getElementById("mm-map-places");
if (placesContainer) {
	const placeCardTemplate = document.getElementById("mm-map-place-template");

	const placesJSONEl = document.querySelector("#mm-places-json .metafield-json");
	const mapboxTokenInput = document.getElementById("mm-mapbox-token");
	const geocoderWrapper = document.querySelector('.mm-map-wrapper #mm-map-geocoder');

	const PLACE_SELECTED_CLASS = "selected";
	const MARKER_DEFAULT_COLOR = "#021208";
	const MARKER_SELECTED_COLOR = "#FF0000";

	mapboxgl.accessToken = mapboxTokenInput.value;

	// DEBUG: Vérifier le JSON
	// console.log("🔍 DEBUG - JSON brut:", placesJSONEl.innerText);

	let places = [];
	try {
		const rawData = JSON.parse(placesJSONEl.innerText);
		// console.log("🔍 DEBUG - JSON parsé:", rawData);
		// console.log("🔍 DEBUG - Nombre d'éléments:", rawData.length);

		places = rawData.map((placeData, index) => {
			// console.log(`🔍 DEBUG - Store ${index}:`, placeData);
			const coords = [parseFloat(placeData.longitude), parseFloat(placeData.latitude)];
			// console.log(`🔍 DEBUG - Coordonnées ${index}:`, coords);

			return {
				name: placeData.name,
				address: placeData.address,
				country: placeData.country,
				phone: placeData.phone,
				coordinates: coords,
			};
		});

		// console.log("🔍 DEBUG - Places finales:", places);
		// console.log("🔍 DEBUG - Nombre de places avec coordonnées valides:", places.filter(p => !isNaN(p.coordinates[0]) && !isNaN(p.coordinates[1])).length);
	} catch (error) {
		// console.error("❌ ERREUR lors du parsing JSON:", error);
		// console.error("JSON brut:", placesJSONEl.innerText);
	}

	function mmInsertPlaceCard(place) {
		const card = placeCardTemplate.content.cloneNode(true).firstElementChild;

		const nameEl = card.querySelector("[data-place-name]");
		nameEl.textContent = place.name;

		const addressEl = card.querySelector("[data-place-address]");
		addressEl.textContent = place.address;

		const cityEl = card.querySelector("[data-place-city]");
		if (cityEl) {
			cityEl.textContent = `${(place.postcode || '')} ${place.city || place.country}`;
		}

		// Téléphone sur sa propre ligne, masqué si absent du JSON
		const phoneEl = card.querySelector("[data-place-phone]");
		if (phoneEl && place.phone) {
			phoneEl.textContent = place.phone;
			phoneEl.hidden = false;
		}

		card.dataset.placeCoordinates = JSON.stringify(place.coordinates);

		// Ajouter directement à la liste sans groupement par pays
		placesContainer.appendChild(card);
	}

	function mmDisplayVisibleMarkers(map) {
		const {
			_ne: {lng: maxEast, lat: maxNorth},
			_sw: {lng: maxWest, lat: maxSouth},
		} = map.getBounds();

		const visiblePlaces = places.forEach((place) => {
			const [lng, lat] = place.coordinates; // [-1.557900, 47.214370]

			const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;
			if (visible) {
				mmInsertPlaceCard(place);
			}
		});
	}

	function mmFlyToPlaceByCoordinates(coordinates) {
		const map = window.mmMap;
		map.flyTo(
			{center: coordinates, zoom: 15},
			{placeCoordinatesToSelect: coordinates}
		);
	}

	function mmSelectPlaceByCoordinates(coordinates) {
		Array.from(placesContainer.children).forEach((placeCard) => {
			placeCard.classList.remove(PLACE_SELECTED_CLASS);

			const [cardLng, cardLat] = JSON.parse(placeCard.dataset.placeCoordinates);
			const [lng, lat] = coordinates;
			if (cardLng === lng && cardLat === lat) {
				placeCard.classList.add(PLACE_SELECTED_CLASS);
			}
		});

		mmHighLightPlaceMarkerByCoordinates(coordinates);
	}

	function mmHighLightPlaceMarkerByCoordinates(coordinates) {
		const [lng, lat] = coordinates;
		const markers = document.querySelectorAll("#mm-map .custom-marker");

		markers.forEach((marker) => {
			const [markerLng, markerLat] = JSON.parse(marker.dataset.placeCoordinates);

			if (markerLng === lng && markerLat === lat) {
				marker.classList.add('selected');
			} else {
				marker.classList.remove('selected');
			}
		});
	}

	function mmInitMap() {
		const map = new mapboxgl.Map({
			container: "mm-map",
			style: "mapbox://styles/mapbox/streets-v12",
			center: [2.25, 46.45],
			zoom: 4,
		});

		window.mmMap = map;

		// Ajout du champ de recherche
		const geocoder = new MapboxGeocoder({
			mapboxgl: mapboxgl,
			accessToken: mapboxgl.accessToken,
			placeholder: 'Entrez un code postal ou une adresse...',
			countries: "de,au,ie,ca,gb,ch,se,ae,jp,qa,it,fr,gf",
		});
		geocoderWrapper.appendChild(geocoder.onAdd(map));

		// Gérer le clic sur l'icône de recherche (qui remplace l'icône de fermeture)
		setTimeout(() => {
			const closeButton = geocoderWrapper.querySelector('.mapboxgl-ctrl-geocoder--icon-close');
			if (closeButton) {
				closeButton.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();

					// Déclencher la recherche
					const input = geocoderWrapper.querySelector('input');
					if (input && input.value.trim()) {
						geocoder.query(input.value.trim());
					}
				});
			}
		}, 100);

		// Ajout du contrôle de géolocalisation
		map.addControl(
			new mapboxgl.GeolocateControl({
				positionOptions: {enableHighAccuracy: true},
				trackUserLocation: true,
				showUserHeading: true,
			})
		);

		// Conversion des lieux en GeoJSON
		const geojson = {
			type: "FeatureCollection",
			features: places.map((place) => ({
				type: "Feature",
				geometry: {type: "Point", coordinates: place.coordinates},
				properties: {
					name: place.name,
					address: place.address,
					country: place.country,
				},
			})),
		};

		map.on("load", () => {
			// console.log("🔍 DEBUG - Carte chargée, ajout des marqueurs...");
			// console.log("🔍 DEBUG - Nombre de places à afficher:", places.length);

			// Charger l'icône SVG personnalisée
			const svgIcon = `
				<svg xmlns="http://www.w3.org/2000/svg" width="34" height="42" viewBox="0 0 34 42" fill="none">
					<path d="M16.6667 0C12.2464 0 8.00716 1.75595 4.88155 4.88155C1.75595 8.00716 0 12.2464 0 16.6667C0 20.6083 0.8375 23.1875 3.125 26.0417L16.6667 41.6667L30.2083 26.0417C32.4958 23.1875 33.3333 20.6083 33.3333 16.6667C33.3333 12.2464 31.5774 8.00716 28.4518 4.88155C25.3262 1.75595 21.0869 0 16.6667 0Z" fill="#0D1744"/>
					<path d="M16.6641 22.917C20.1158 22.917 22.9141 20.1188 22.9141 16.667C22.9141 13.2152 20.1158 10.417 16.6641 10.417C13.2123 10.417 10.4141 13.2152 10.4141 16.667C10.4141 20.1188 13.2123 22.917 16.6641 22.917Z" fill="white"/>
				</svg>
			`;

			const img = new Image(34, 42);
			img.onload = () => map.addImage('custom-marker', img);
			img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgIcon);

			// Ajout de la source des clusters
			map.addSource("places", {
				type: "geojson",
				data: geojson,
				cluster: true,
				clusterMaxZoom: 14,
				clusterRadius: 50,
			});

			// Ajout du calque pour les clusters (cercles par défaut)
			map.addLayer({
				id: "clusters",
				type: "circle",
				source: "places",
				filter: ["has", "point_count"],
				paint: {
					"circle-color": "#0D1744",
					"circle-radius": ["step", ["get", "point_count"], 20, 100, 30, 750, 40],
				},
			});

			map.addLayer({
				id: "cluster-count",
				type: "symbol",
				source: "places",
				filter: ["has", "point_count"],
				layout: {
					"text-field": "{point_count_abbreviated}",
					"text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
					"text-size": 12,
				},
				paint: {
					"text-color": "#ffffff",
				},
			});

			// Ajout du calque pour les points individuels avec icône SVG
			map.addLayer({
				id: "unclustered-point",
				type: "symbol",
				source: "places",
				filter: ["!", ["has", "point_count"]],
				layout: {
					"icon-image": "custom-marker",
					"icon-size": 1,
					"icon-allow-overlap": true,
				},
			});

			// Clic sur un cluster → Zoom sur le groupe
			map.on("click", "clusters", (e) => {
				const features = map.queryRenderedFeatures(e.point, {layers: ["clusters"]});
				const clusterId = features[0].properties.cluster_id;
				map.getSource("places").getClusterExpansionZoom(clusterId, (err, zoom) => {
					if (err) return;
					map.easeTo({center: features[0].geometry.coordinates, zoom});
				});
			});

			// Clic sur un point individuel → Centrer sur ce point
			map.on("click", "unclustered-point", (e) => {
				const coordinates = e.features[0].geometry.coordinates.slice();
				mmFlyToPlaceByCoordinates(coordinates);
			});

			// console.log("🔍 DEBUG - Marqueurs ajoutés, affichage des cartes...");
			// Affiche les cards au chargement de la page
			mmDisplayVisibleMarkers(map);

			// Mise à jour des marqueurs affichés après déplacement de la carte
			map.on("moveend", (event) => {
				placesContainer.innerHTML = null;
				if (map.getZoom() > 2) mmDisplayVisibleMarkers(map);
				if (event.placeCoordinatesToSelect) mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
			});

			// Clic sur une carte → Vol vers le lieu
			placesContainer.addEventListener("click", (event) => {
				const target = event.target.closest(".mm-map-place-card");
				if (target) mmFlyToPlaceByCoordinates(JSON.parse(target.dataset.placeCoordinates));
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	mmInitMap();

	// Déclenche un redimensionnement 200ms après init
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 2000);
});
